export enum AddressProperties {
  AddressLine1 = 'addressLine1',
  AddresLine2 = 'addresLine2',
  State = 'state',
  Zip = 'zip',
  City = 'city',
  Country = 'country',
  Region = 'region',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
}
export enum AddressMetaProperties {}
